import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core'

export const useTreeViewContainerStyles = makeStyles((theme: Theme) => ({
    treeContainer: {
        height: `calc(100% - 90px)`,
        width: '100%',
        marginTop: pxToRem(0),
        scrollbarGutter: 'stable',
        overflowY: 'hidden',
        padding: `${pxToRem(0)} ${pxToRem(5)} ${pxToRem(8)} ${pxToRem(30)}`,
        backgroundColor: '#fff',
        '@media (max-width: 1600px)': {
            height: 'calc(100% - 135px)',
        },
        '@media (max-width: 1460px)': {
            height: 'calc(100% - 135px)',
        },
        '@media (max-height: 700px)': {
            paddingBottom: pxToRem(50),
        },
    },
    tree: {
        width: '100%',
        overflowY: 'hidden',
        backgroundColor: '#fff',
        '& .ant-tree-title': {
            width: '100% !important',
        },
        '& .ant-tree-list-holder': {
            paddingRight: pxToRem(20),
            paddingLeft: pxToRem(0),
            overflow: 'visible', // Allow content to overflow if needed
            '& .ant-tree-list-holder-inner': {
                paddingLeft: theme.spacing(1),
                paddingRight: pxToRem(5), // Reduced to prevent text cutoff
                scrollBehavior: 'smooth',
                overflow: 'visible',
            },
        },
        '& .ant-tree-list-scrollbar': {
            width: `${pxToRem(6)} !important`,
            scrollbarColor: '#9D9D9D #fff',
        },
        '& .ant-tree-treenode:last-child': {
            marginBottom: pxToRem(20),
        },
        '& .ant-tree .ant-tree-treenode:last-child': {
            marginBottom: pxToRem(20),
        },
        '& .ant-tree-treenode': {
            width: '100%',
            lineHeight: 1.7,
            marginBottom: 'unset',
            position: 'relative',
        },
        '& .ant-tree-node-content-wrapper:hover': {
            cursor: 'default',
            background: 'transparent',
        },
        '& .ant-tree-node-content-wrapper': {
            width: '100% !important',
            display: 'flex',
            alignItems: 'start',
            minHeight: 'inherit',
        },
        '@media (max-width: 1024px)': {
            width: 250,
            '& .wrappedDraggable': {
                minWidth: 450,
            },
        },
        '& .ant-tree-switcher': {
            marginTop: -1.095,
            display: 'none',
            '&:hover': {
                background: 'transparent',
                cursor: 'default',
            },
        },
        '& .ant-tree-treenode-draggable .ant-tree-draggable-icon': {
            alignContent: 'center',
            marginTop: pxToRem(2),
            color: '#555555',
            visibility: 'hidden',
            '&:hover': {
                background: '#EEEEEE',
                borderRadius: '2px',
                transition: 'all 0.2s ease-in-out',
            },
        },
        '& .ant-tree-treenode.tree-header-node .ant-tree-indent': {
            paddingLeft: pxToRem(0),
        },
        '& .ant-tree-indent': {
            paddingLeft: pxToRem(96),
        },
        '& .ant-tree-node-content-wrapper .ant-tree-iconEle': {
            position: 'absolute',
            left: '-93px',
            color: '#555555',
            visibility: 'hidden',
            width: '96px',
        },
        '& .ant-tree-node-content-wrapper.ant-tree-node-selected': {
            background: 'transparent',
            borderRadius: '4px',
        },
        '& .ck-label.ck-voice-label': {
            display: 'none',
        },
        '& .ant-tree .ant-tree-treenode.ant-tree-treenode-disabled.ant-tree-treenode-selected .ant-tree-node-content-wrapper': {
            backgroundColor: theme.palette.common.white,
        },
        '& .ant-tree-treenode-disabled.ant-tree-treenode-selected .ant-tree-node-content-wrapper': {
            backgroundColor: '#FFFFFF !important',
        },
        '& .ck-content .ck-suggestion-marker-insertion.ck-suggestion-marker--active': {
            background: '#66e57759',
            borderBottom: '3px solid #1eae3159',
            borderTop: '3px solid #1eae3159',
        },
        '& .ck-content .ck-suggestion-marker-deletion, .ck-content .ck-suggestion-marker-deletion.ck-suggestion-marker--active': {
            borderTop: '3px solid #ae1e4259',
            borderBottom: '3px solid #ae1e4259',
            textDecorationColor: '#D43636',
            background: '#e5668659',
            color: '#D43636',
            textDecorationThickness: 1,
        },
    },
}))

export const useTreeViewStyles = makeStyles((theme: Theme) => ({
    hyperlinkWrapper: {
        '&&': {
            marginTop: 5,
            marginBottom: 5,
            display: 'block',
        },
    },
    iconOutlinedTitle: {
        color: 'rgba(0, 0, 0, 0.25)',
        '&:hover': {
            color: '#555555',
            transition: 'all 0.2s ease-in-out',
        },
    },
    articleContainer: {
        display: 'flex',
        width: '100%',
        boxSizing: 'inherit',
        borderRadius: pxToRem(4),
        margin: '5px 0px',
        padding: '5px 10px',
        paddingRight: 0,
    },
    itemOrderTypography: {
        paddingRight: pxToRem(10),
    },
    articleTypography: {
        color: '#314959',
        fontSize: '16px',
        fontFamily: 'Roboto',
        cursor: 'text',
        outline: 'none',
    },
    paragraphTypography: {
        fontSize: '14px',
        fontFamily: 'Roboto',
        cursor: 'text',
        outline: 'none',
        alignItems: 'flex-start',
        lineHeight: 2,
    },
    inBetweenLine: {
        margin: `0 ${pxToRem(2.5)}`,
    },
    addIcon: {
        cursor: 'pointer',
        marginTop: theme.spacing(0.2),
    },
    visibilityIcon: {
        cursor: 'pointer',
        marginTop: theme.spacing(0.25),
    },
    visibilityIconArticle: {
        cursor: 'pointer',
        marginTop: pxToRem(3),
    },
    visibilityIconDisabled: {
        marginTop: pxToRem(2.5),
    },
    disabledAddIcon: {
        cursor: 'default',
        opacity: 0.5,
        color: 'rgba(0,0,0,0.5)',
        marginTop: theme.spacing(0.25),
    },
    switcherLoadingIcon: {},
    switcherHiddenIcon: {
        display: 'none',
    },
    productGroupIcon: { marginTop: pxToRem(4) },
    productTypeIcon: { marginTop: pxToRem(6) },
    specifierNoteDeleteIcon: {
        color: '#04325B',
        position: 'relative',
        padding: pxToRem(5),
        top: pxToRem(-5),
        left: pxToRem(10),
        cursor: 'pointer',
        opacity: 0.25,
        '&:hover': {
            opacity: 1,
            transition: 'opacity 0.2s ease-in-out',
        },
    },
    specifierNoteContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        color: '#04325B',
        width: 'calc(100% - 10px)',
        margin: '10px 0px',
        marginRight: 'unset',
        padding: theme.spacing(0.625, 1),
        fontSize: '14px',
        fontFamily: 'Roboto',
        fontWeight: 400,
        minHeight: pxToRem(38),
        border: '1px solid transparent',
        backgroundColor: '#D9F3F9',
        '&.disabled': {
            textDecoration: 'line-through',
            textDecorationColor: 'rgba(0,0,0,0.5) !important',
            color: '#666666',
            backgroundColor: '#F5F5F5',
            border: 'none',
            cursor: 'default',
        },
        borderRadius: pxToRem(4),
        cursor: 'text',
        outline: 'none',
        marginLeft: theme.spacing(3),
    },
    assemblyTextField: {
        '& .MuiInputBase-formControl': {
            minHeight: pxToRem(36),
            fontSize: pxToRem(10),
            maxWidth: pxToRem(514),
            minWidth: pxToRem(100),
            padding: '5px 10px',
        },
        '& .MuiInputBase-root': {
            lineHeight: pxToRem(20),
        },
        width: '100%',
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    inputText: {
        fontSize: pxToRem(14),
        cursor: 'text',
    },
    displayWrap: {
        display: 'inline-flex',
        flexFlow: 'nowrap',
        gap: pxToRem(4),
    },
    displayContent: {
        display: '-webkit-inline-box',
        minWidth: 'auto',
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',
        // Force all children to be inline for cohesive content flow
        '& > *': {
            display: 'inline !important',
            verticalAlign: 'baseline',
        },
    },
    addedText: {
        background: '#C3FFCC',
        color: '#0D7B55',
    },
    removedText: {
        color: '#D43636',
        background: '#F6CAD5',
        textDecoration: 'line-through',
        textDecorationColor: '#D43636',
        cursor: 'default',
    },
    inactiveText: {
        textDecoration: 'line-through',
        textDecorationColor: 'rgba(0,0,0,0.5) !important',
        color: 'rgba(0,0,0,0.5) !important',
        backgroundColor: theme.palette.common.white,
        cursor: 'default',
        // Remove line-through for NodeOrder
        '&.node-order': {
            textDecoration: 'none !important',
        },
    },
    tooltipTitle: {
        fontSize: '13px',
        fontWeight: 500,
    },
    tooltipSubtitle: {
        fontSize: '11px',
        fontWeight: 400,
        textAlign: 'center',
    },
    iconContainer: {
        width: pxToRem(24),
        height: pxToRem(24),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            background: '#EEEEEE',
            borderRadius: '2px',
            transition: 'all 0.2s ease-in-out',
        },
    },
    iconContainerArticle: {
        marginBottom: theme.spacing(0.25),
        paddingBottom: pxToRem(3),
    },

    nodeOrderPadding: {
        display: 'flex',
        alignItems: 'flex-start',
    },
    readOnlyCursor: {
        cursor: 'default',
    },
    editableText: {
        borderTop: '3px solid #8DDD98',
        borderBottom: '3px solid #8DDD98',
    },
    hiddenHoveredIcon: {
        visibility: 'hidden',
        width: pxToRem(24),
    },
    nonArticleNodes: {
        marginLeft: -theme.spacing(0.5),
    },
    dragIconContainer: {
        marginBottom: theme.spacing(0.125),
        width: pxToRem(24),
    },
    switcherIconContainer: {
        cursor: 'pointer',
        width: pxToRem(24),
    },
    switcherIcon: {
        marginTop: -theme.spacing(0.625),
    },
    switcherIconCollapsed: {
        marginTop: -3,
    },
    disabledSwitcherIcon: {
        cursor: 'default',
        opacity: 0.5,
        color: 'rgba(0,0,0,0.5)',
        marginTop: -3,
        pointerEvents: 'none',
    },
    hiddenContainer: {
        display: 'none !important',
    },
    dragIndicator: {
        fontSize: '20px !important',
        paddingTop: theme.spacing(0.25),
    },
    disabledIcon: {
        opacity: 0.5,
        pointerEvents: 'none',
        cursor: 'not-allowed',
    },
    enabledIcon: {
        opacity: 1,
        pointerEvents: 'auto',
        cursor: 'pointer',
    },
    productIconWrapper: {
        display: 'inline-flex',
        alignItems: 'center',
    },
    productLibraryButton: {
        border: '1px solid #C9C9C9',
        borderRadius: pxToRem(100),
        color: '#314959',
        lineHeight: 1.43,
        height: pxToRem(26),
        minWidth: pxToRem(125),
        fontSize: pxToRem(14),
        padding: theme.spacing(0.625, 1.25),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1.25),
        marginLeft: pxToRem(38),
        '& .MuiButton-startIcon': {
            marginRight: theme.spacing(0.5),
            marginLeft: 0,
        },
        '& .MuiSvgIcon-root': {
            fontSize: pxToRem(16),
        },
    },
    customManufacturerNode: {
        pointerEvents: 'none',
        marginLeft: pxToRem(38),
        marginBottom: pxToRem(6),
    },
    headerNode: {
        '& .ant-tree-treenode.tree-header-node': {
            padding: 0,
            marginBottom: pxToRem(0),
            '& .ant-tree-node-content-wrapper': {
                padding: 0,
                cursor: 'default',
                width: '100%',
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            },
            '& .ant-tree-switcher': {
                display: 'none !important',
            },
            '& .ant-tree-iconEle': {
                display: 'none !important',
            },
            '& .ant-tree-draggable-icon': {
                display: 'none !important',
            },
        },
    },
}))
